import { useState } from "react";
import { NavLink } from "react-router-dom";
import pagesData from "../pagesData";

export default function Sidebar({ onMenuClick }) {
  const [search, setSearch] = useState("");

  // Filter pages based on search input (case-insensitive)
  const filteredData = pagesData
    .map((section) => ({
      ...section,
      pages: section.pages.filter((page) =>
        page.name.toLowerCase().includes(search.toLowerCase())
      ),
    }))
    .filter((section) => section.pages.length > 0);

  return (
    <aside className="w-64 xl:w-72 bg-color-white md:h-[calc(100dvh_-_69px)] h-[calc(100dvh_-_53px)] sticky md:top-[69px] top-[53px] overflow-y-auto border-r border-color-gray-200 py-5 pl-5 block space-y-8 dark:bg-color-gray-800 dark:border-color-gray-700 pt-0">
      <div className="pt-5 pr-5 sticky top-0 z-10 bg-color-white dark:bg-color-gray-800 relative">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-3 py-2 rounded border border-color-gray-300 dark:border-color-gray-700 bg-color-white dark:bg-color-gray-900 text-sm focus:outline-none focus:ring-1 dark:text-color-white focus:ring-color-violet-600"
        />
        {search && (
          <button
            type="button"
            onClick={() => setSearch("")}
            className="absolute right-6 bg-color-transparent cursor-pointer mt-[9px] top-1/2 -translate-y-1/2 text-color-gray-400 hover:text-color-gray-600 dark:hover:text-color-gray-200 p-1"
            aria-label="Clear search"
            tabIndex={0}
          >
            <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
              <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M4 4l8 8M12 4l-8 8" />
            </svg>
          </button>
        )}
      </div>
      {filteredData.map((section) => (
        <div key={section.section}>
          <h2 className="mb-3 font-mono text-sm/6 font-medium tracking-widest text-color-gray-500 uppercase sm:text-xs/6 dark:text-color-gray-400">
            {section.section}
          </h2>
          <ul className="space-y-2 text-sm">
            {section.pages.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  onClick={() => {
                    window.scrollTo({ top: 0 , behavior: 'smooth' });
                    if (onMenuClick) onMenuClick();
                  }}
                  className={({ isActive }) =>
                    `block transition-all leading-none py-[7px] no-underline border-l-2 border-color-transparent ${isActive
                      ? "pl-3  bg-gradient-[linear-gradient(90deg,color-pink-200/50,#ffffff00_90%)] text-color-pink-800 font-semibold border-color-pink-600 dark:text-color-white  dark:bg-gradient-[linear-gradient(90deg,color-pink-600/10,color-pink-600/0)]"
                      : "text-color-gray-600 dark:text-color-gray-300 hover:text-color-gray-800"
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </aside>
  );
}
